import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Agent: AppRouteModule = {
  path: '/agentManage',
  name: 'AgentManage',
  identify: 'agentManage',
  component: LAYOUT,
  redirect: '/agentManage/agentList',
  meta: {
    icon: 'icons8:group',
    title: '代理商管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'agentList',
      name: 'AgentList',
      component: () => import('@/views/agentManage/agentList/index.vue'),
      identify: 'agentList',
      meta: {
        title: '代理商列表',
        roles: [RoleEnum.OFFLINE],
      }
    }
  ]
};

export default Agent;
